export enum GridConnectionType {
  vdeAr4105 = 1,
  vdeAr4110 = 2,
  vdeAr4120 = 3,
}
